module.exports = __webpack_public_path__ + "static/media/badge_yuyan.e8a916bc.png";